export class UniquePromise {
  private promise!: Promise<any> | null;
  private runOnlyOnce = true;

  constructor(runOnlyOnce: boolean = true) {
    this.runOnlyOnce = runOnlyOnce;
  }

  /**
   * Executes a piece of logic once, in a wrapped promise, regardless of how many times it's called during it's execution.
   * @param asyncLogic The async logic that this promise should execute.
   */
  async run(asyncLogic) {
    if (!this.promise) {
      this.promise = new Promise<void>(async (resolve) => {
        await asyncLogic();
        return resolve();
      })
      .then(() => {
        if (!this.runOnlyOnce) {
          this.promise = null
        }
      });
    }

    return this.promise;
  }
}
